export default "__VITE_ASSET__BTD20pUw__"